import { create } from 'zustand';

interface WelcomeModalState {
  isOpen: boolean;
  isCheckModalOpen: boolean;
  onCheckModalOpen: () => void;
  onWelcomeClose: () => void;
  onWelcomeMapOpen: () => void;
}

export const useWelcomeModalStore = create<WelcomeModalState>(set => ({
  isOpen: false,
  isCheckModalOpen: false,
  onCheckModalOpen: () => set({ isCheckModalOpen: true }),
  onWelcomeClose: () => set({ isOpen: false }),
  onWelcomeMapOpen: () => set({ isOpen: true }),
}));
